export const MOUSE_BUTTON = {
  left: 0,
  middle: 1,
  right: 2,
};
